import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoOutlook = () => {
  return (
    <g>
      <path d="M9.39 0v16L0 14.165V1.615L9.39 0zM16 5.205l-.004 5.499c.065 1.016-.712 1.124-.712 1.124h-5.31V7.619c.54.631 1.483.724 2.136.21L16 5.205zm-11.282-.18c-1.18 0-2.138 1.27-2.138 2.837 0 1.568.958 2.838 2.138 2.838 1.181 0 2.138-1.27 2.138-2.838 0-1.567-.957-2.838-2.138-2.838zm-.025 1.151c.568 0 1.028.753 1.028 1.682 0 .928-.46 1.681-1.028 1.681-.568 0-1.028-.753-1.028-1.681 0-.93.46-1.682 1.028-1.682zm10.634-2.928a.589.589 0 0 1 .63.64l-4.84 3.216-1.144-.728V3.248z" />
    </g>
  );
};

export default withIcon(IconLogoOutlook);
